export type Listener<T> = (payload: T) => void;

/** Tiny typed emitter. Listener errors never break the emitting path. */
export class Emitter<M extends Record<string, unknown>> {
  private map = new Map<keyof M, Set<Listener<never>>>();

  on<K extends keyof M>(key: K, fn: Listener<M[K]>): () => void {
    let set = this.map.get(key);
    if (!set) {
      set = new Set();
      this.map.set(key, set);
    }
    set.add(fn as Listener<never>);
    return () => {
      this.map.get(key)?.delete(fn as Listener<never>);
    };
  }

  emit<K extends keyof M>(key: K, payload: M[K]): void {
    const set = this.map.get(key);
    if (!set) return;
    for (const fn of [...set]) {
      try {
        (fn as Listener<M[K]>)(payload);
      } catch (error) {
        console.error(`listener for ${String(key)} failed`, error);
      }
    }
  }
}
